import React from 'react';
import { Login, LoginProps } from 'react-admin';
import GoogleLoginForm from './GoogleLoginForm';

const GoogleLoginPage = (props: LoginProps) => {
  return (
    <Login {...props} backgroundImage="https://source.unsplash.com/random/1600x900/daily">
      <GoogleLoginForm />
    </Login>
  );
};

export default GoogleLoginPage;
